import { render, staticRenderFns } from "./loginSwitch.vue?vue&type=template&id=fb994072"
import script from "./loginSwitch.vue?vue&type=script&lang=js"
export * from "./loginSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports